import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Loading from './components';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const user = useSelector(state => state?.user);
    const {userDetails, isLoggedIn, loading} = user

    const userRole = userDetails?.role

    if (loading.login) {
        return (
          <div
            style={{
              height: '90vh',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex'
            }}
          >
            <div
              style={{
                display: 'flex',
                gap: '5px'
              }}
            >
              Loading
              <Loading size="30px" />
            </div>
          </div>
        );
      }
    

    if (!isLoggedIn) {
        return <Navigate to="/" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(userRole)) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;